// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headerMobile":"CYMv7o","burgerHolder":"_1XV_sk","open":"bAEdig","burger":"PYCjXL"};